import { useEffect, useState } from "react";
import {
  getPaddle,
  isPaddleConfigured,
  arePaddlePricesConfigured,
  openPaddleCheckout,
  PADDLE_PRICE_IDS,
} from "@/lib/paddle";

/**
 * usePaddle — React hook over the singleton Paddle.js instance.
 *
 * Returns:
 *   ready        Paddle.js initialized and usable
 *   configured   client token present in env
 *   pricesReady  all four price IDs configured
 *   priceIds     resolved PADDLE_PRICE_IDS map
 *   openCheckout(priceId, options) → Promise<boolean>
 */
export function usePaddle() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!isPaddleConfigured()) return undefined;
    getPaddle()
      .then((p) => { if (!cancelled) setReady(Boolean(p)); })
      .catch(() => { if (!cancelled) setReady(false); });
    return () => { cancelled = true; };
  }, []);

  return {
    ready,
    configured: isPaddleConfigured(),
    pricesReady: arePaddlePricesConfigured(),
    priceIds: PADDLE_PRICE_IDS,
    openCheckout: openPaddleCheckout,
  };
}

export default usePaddle;
